export default {
  blockchain: {},
  blockchainUserSelected: false,
  blockchainResponse: {},
  blockchainError: null,
  blockchainInput: null,
  blockchainInfo: null,
  blockchainClearState: false,
  blockchainDropdown: {
    select: false,
    input: false,
  },
  blockchainRequestsOpen: false,
  blockchainRecentQueriesState: false,
  blockchainMultiSelectState: false,
}
